// src/componentes/common/dialogService.js
// Imperative async confirm/prompt API — returns Promises resolved by KyeConfirm.

let _showDialog = null;

export function _registerDialogHandler(fn) {
  _showDialog = fn;
}

export const dialogService = {
  // confirm(message)  → confirmación simple (retrocompatible).
  // confirm(message, opts) → confirmación con resumen estructurado:
  //   opts.titulo       string   — encabezado (ej. "Cancelar pago")
  //   opts.detalles     [{label, value}] — filas de resumen (monto, cliente…)
  //   opts.peligro      bool     — estilo destructivo (rojo) en el botón
  //   opts.confirmText  string   — texto del botón confirmar (ej. "Sí, cancelar")
  // UX-1 (2026-06-17): las acciones irreversibles muestran qué se va a afectar.
  confirm(message, opts = {}) {
    return new Promise((resolve) => {
      if (!_showDialog) {
        // fallback while component mounts
        resolve(window.confirm(message));
        return;
      }
      _showDialog({ type: "confirm", message, resolve, ...opts });
    });
  },

  prompt(message, defaultValue = "") {
    return new Promise((resolve) => {
      if (!_showDialog) {
        resolve(window.prompt(message, defaultValue));
        return;
      }
      _showDialog({ type: "prompt", message, defaultValue, resolve });
    });
  },
};
